var _style, _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 230.2 230.2",
    style: {
      enableBackground: "new 0 0 230.2 230.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:url(#SVGID_1_);}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 115.3,
    cy: 115.1,
    r: 96.3
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 115.2781,
    cy: 116.92,
    r: 115.08,
    gradientTransform: "matrix(1 0 0 -1 0 232)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5FACEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M95.4,105.8c-4-4.4-6.4-9.8-6.4-16c0-2.7,0.5-5.4,0.8-8.1c0.3-3.7,2.2-6.7,4.3-9.5c3.7-4.9,8.4-8.5,14.5-9.8 c5.7-1.6,11.4-1.2,16.8,1c8.5,3.5,13.9,9.7,15.9,18.9c1.7,7.7,0.3,14.6-4,21c-4.2,6.2-10.2,9.8-17.5,11.1 C110.1,116.2,101.9,113,95.4,105.8z M230.4,115.1c0,63.6-51.5,115.1-115.1,115.1S0.2,178.6,0.2,115.1S51.7,0,115.3,0 S230.4,51.5,230.4,115.1z M78.4,95.3c0.3,1.2,0.6,2.4,0.9,3.5c3.3,11,10.3,19,20.6,23.8c7.5,3.5,15.4,4.6,23.8,2.4 c8.4-2.2,15.5-6.2,20.8-12.8c9.2-11.3,11-24.3,6.1-37.7c-3.7-10-10.9-17.2-21.1-21.1c-3-1.1-6.1-1.8-9.1-2.7c-0.5,0-1,0-1.4,0 c-1.5,0-3.1,0-4.6,0c-1.7,0.2-3.4,0.3-5.2,0.5c-7.3,0.8-13.6,4.2-18.9,9c-5.8,5.2-9.7,11.6-11.5,19.2C77.5,84.7,77.1,90,78.4,95.3z  M180.6,173.6c-0.1-2.9-0.3-5.9-0.9-8.8c-2.6-13.6-10.5-23.5-22.4-30.2c-7.2-4-15-5.3-23.1-5.3c-12.1,0-24.3-0.1-36.4,0 c-3.4,0-6.9,0.4-10.3,0.8c-11.1,1.4-19.9,7-27,15.4c-2.4,2.8-4.1,6.2-5.9,9.4c-2.6,4.6-3.7,9.7-4.3,14.9c-0.4,3.1-0.7,6.4,2.6,8.6 c1.5,1,2.9,1.3,4.6,0.6c1.9-0.9,3.4-2.1,3.6-4.4c0.2-2.7,0.3-5.4,0.9-8.1c1.9-8.4,6.5-15.1,13.5-20.2c6.1-4.4,12.9-5.9,20.2-6 c6.5-0.1,13.1,0,19.6,0c0-0.1,0-0.2,0-0.3c8.8,0.4,17.6,0.3,26.3,1.1c10.6,1.1,18.3,7.1,23.6,16.1c3,5,4.4,10.5,4.4,16.4 c0,3,2.7,5.9,5.5,5.9C178.4,179.5,180.7,177.1,180.6,173.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profileIcon.8f72bb2026f85e26de377132cbca3fb2.svg";
export { ForwardRef as ReactComponent };